<div class="sidebar-panel">
  <div
    id="scroll-area"
    [perfectScrollbar]
    class="navigation-hold"
    fxLayout="column"
    >
    <div class="sidebar-hold">
      <!-- App Logo -->
      <div class="branding px-20">
        <span class="app-logo-text">SABIS<sup>®</sup> Careers</span>

        @if (layoutConf.sidebarStyle !== 'compact') {
          <span
            style="margin: auto"
          ></span>
        }
        @if (layoutConf.sidebarStyle !== 'compact') {
          <mat-slide-toggle
            fxHide.lt-md
            (change)="toggleCollapse()"
            [checked]="!layoutConf.sidebarCompactToggle"
          ></mat-slide-toggle>
        }
      </div>

      <!-- Navigation -->
      <app-sidenav
        [items]="menuItems"
        [hasIconMenu]="hasIconTypeMenuItem"
        [iconMenuTitle]="iconTypeMenuTitle"
      ></app-sidenav>
    </div>
  </div>
</div>
